/**
 * Closes the cart drawer as soon as the cart becomes empty (last item removed,
 * or an order placed through the Norel order page).
 */
import { StandardEvents } from '@shopify/events';

const CLOSE_DELAY_MS = 600; // lets the customer see the last item disappear

export function closeCartDrawer() {
  const drawer = document.getElementById('cart-drawer');
  if (drawer && drawer.isOpen && typeof drawer.close === 'function') drawer.close();
}

document.addEventListener(StandardEvents.cartLinesUpdate, (event) => {
  event.promise
    ?.then(({ cart, detail } = {}) => {
      const count = cart?.totalQuantity ?? detail?.itemCount;
      if (count === 0) setTimeout(closeCartDrawer, CLOSE_DELAY_MS);
    })
    .catch(() => {});
});

// The order page announces a placed order; the cart is empty from then on.
document.addEventListener('norel:order-placed', closeCartDrawer);
